import { render, staticRenderFns } from "./project-management-modal.vue?vue&type=template&id=225c25b4&"
import script from "./project-management-modal.vue?vue&type=script&lang=ts&"
export * from "./project-management-modal.vue?vue&type=script&lang=ts&"
import style0 from "./project-management-modal.vue?vue&type=style&index=0&id=225c25b4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports